import {gridViewSvg as Icon__small__gridViewSvg} from '../Icon__small/Icon__small--gridView.js';
import {gridViewSvg as Icon__xsmall__gridViewSvg} from '../Icon__xsmall/Icon__xsmall--gridView.js';

export var gridView = {
  name: 'gridView',
  category: 'icon',
  colorable: true,
  svg: Icon__small__gridViewSvg,
  alt: {
    Icon__small: Icon__small__gridViewSvg,
    Icon__xsmall: Icon__xsmall__gridViewSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
